var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2305 4.61446C11.1368 4.61446 12.2765 4.0064 12.9352 3.18832C13.556 2.45024 13.9951 1.42614 13.9951 0.40204C13.9966 0.267064 13.9839 0.132305 13.9572 0C12.9472 0.0380038 11.7456 0.674067 11.021 1.51615C10.4521 2.16422 9.92116 3.18832 9.92116 4.22642C9.9218 4.34806 9.93451 4.46934 9.95908 4.58846C10.0486 4.60504 10.1395 4.61374 10.2305 4.61446ZM15.4463 10.6291C15.4463 8.06281 17.4902 6.90869 17.606 6.81868C16.2607 4.88649 14.2167 4.83448 13.6478 4.83448C12.1468 4.83448 10.9172 5.75458 10.1287 5.75458C9.30038 5.75458 8.20054 4.88649 6.88114 4.88649C4.39803 4.88649 1.875 6.94869 1.875 10.8371C1.875 13.2613 2.80716 15.8156 3.96089 17.4597C4.95693 18.8599 5.82323 20 7.06478 20C8.30634 20 8.84927 19.1839 10.3763 19.1839C11.9432 19.1839 12.2925 19.974 13.6498 19.974C15.0071 19.974 15.8994 18.7439 16.7537 17.5118C17.7118 16.1116 18.113 14.7375 18.125 14.6735C18.0472 14.6475 15.4463 13.5974 15.4463 10.6291Z",
    fill: "#0D111A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.389f19ad.svg";
export { ForwardRef as ReactComponent };